'use client';

import { S } from './CardHeader.styles';
import type { CardHeaderProps } from './CardHeader.types';

export const CardHeader = ({ variant = 'default', ...otherProps }: CardHeaderProps) => (
  <S.Container variant={variant} {...otherProps} />
);
